import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl'
import AssemblyPartsForm from './assembly/form.component.jsx'

class AssemblyEditForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            assembly: this.props.value || {
                parts: []
            },
            formulas: this.props.formulas,
            terms: this.props.terms,
            hasCalculator: this.props.hasCalculator,
        }

        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.handlePartsChange = this.handlePartsChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            formulas: nextProps.formulas || [],
            terms: nextProps.terms || [],
            hasCalculator: nextProps.hasCalculator || false,
        })
    }

    handlePartsChange(parts, formulas) {
        this.setState({
            assembly: {
                parts: parts
            },
            formulas: formulas,
        }, () => {
            this.onChange(this.state.assembly, this.state.formulas)
        })
    }

    render() {
        return (
            <div className="col-12 ui-module">
                <h5>
                    <FormattedMessage
                        id="product.assembly.form.edit.title"
                        defaultMessage="Assembly configuration"
                    />
                </h5>
                <AssemblyPartsForm
                    hasCalculator={this.state.hasCalculator}
                    formulas={this.state.formulas}
                    terms={this.state.terms}
                    value={this.state.assembly.parts}
                    onChange={this.handlePartsChange}
                />
            </div>
        );
    }
}

export default AssemblyEditForm


// WEBPACK FOOTER //
// ./src/product/form/assembly.component.jsx